/* Brossange C15 : expériences A/B, partie différée (docs/EXPERIENCES.md). Le script en ligne du head
   (snippets/experience-head.liquid) a déjà choisi les variantes et posé les classes avant le rendu : ce fichier
   1. lit l'accord « Analyse » (API Customer Privacy) ; tant qu'il n'est pas connu, rien n'est écrit ni publié pour
      une variante attribuée par cookie (expositions en attente) ; au refus : cookie, mémoire, attribution de la page
      et _exp du panier retirés ;
   2. pose le cookie visiteur brossange_vid seulement avec l'accord et seulement si une expérience est en cours
      (identifiant aléatoire, 390 jours, moins de 13 mois) ; le retire si aucune expérience n'est déclarée ;
   3. attribue une variante dès l'accord connu, seulement pour une zone pas encore peinte à l'écran ni dépassée
      (aucun changement visible) et dont la variante est rendue dans la page, jamais pour un champ coché (palier) ;
   4. publie brossange_experiment_exposure (id, variante) à la première exposition visible, une fois par session,
      par la file commune window.brossangeQ (brossange-track.js : publication seulement avec l'accord) ;
   5. écrit l'attribut de panier _exp (« id:variante » séparés par des virgules) quand le panier contient un article
      et au bouton Commander ;
   6. QA (?exp=id:variante) : rien n'est publié ni gardé, exposition notée dans BrossangeExp.expositions et
      l'événement DOM brossange:exposition, _exp écrit en « id:qa-variante ».
   Le prix encaissé ne dépend jamais d'une variante : seules les réductions automatiques Shopify font foi. */
(() => {
  'use strict';
  const W = window;
  const D = document;
  const X = W.BrossangeExp;
  const COOKIE = 'brossange_vid';
  const DUREE = 390 * 86400;
  const CLE = 'brossange-exp';
  const CLE_VU = 'brossange-exp-vu';
  const CLE_ECRIT = 'brossange-exp-ecrit';
  const lire = (s, k) => { try { return W[s].getItem(k); } catch (e) { return null; } };
  const ecrire = (s, k, v) => { try { W[s].setItem(k, v); } catch (e) { /* stockage bloqué */ } };
  const effacer = (s, k) => { try { W[s].removeItem(k); } catch (e) { /* stockage bloqué */ } };
  const aCookie = () => D.cookie.indexOf(`${COOKIE}=`) >= 0;
  const oublier = () => {
    D.cookie = `${COOKIE}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
    effacer('localStorage', CLE);
    effacer('sessionStorage', CLE_VU);
    effacer('sessionStorage', CLE_ECRIT);
  };
  // Aucune expérience déclarée (toutes terminées ou archivées) : le cookie visiteur n'a plus d'usage
  if (!X || !Array.isArray(X.cfg) || typeof X.calc !== 'function') {
    if (aCookie()) oublier();
    return;
  }

  const ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  const jour = () => new Date().toISOString().slice(0, 10);
  const ouverte = (x) => !!x.s && (!x.d || jour() >= x.d) && (!x.f || jour() <= x.f);
  const variante = (id, g) => D.querySelector(`.exp-v[data-exp="${id}"][data-exp-v="${g}"]`);
  X.expositions = [];
  // Accord « Analyse » : null tant que l'API n'a pas répondu, puis true ou false
  let etat = null;
  const accordConnu = () => etat === true && !!X.vid;
  // Dernière valeur de _exp écrite dans le panier (session, seulement avec l'accord)
  let dernier = lire('sessionStorage', CLE_ECRIT) || '';

  /* 1. Mémoire des expositions et attribut de panier _exp (80 caractères au plus, liste blanche des webhooks C14) */
  const memoire = () => {
    let m = {};
    try { m = JSON.parse(lire('localStorage', CLE) || '{}') || {}; } catch (e) { m = {}; }
    const ids = X.cfg.map((x) => x.i);
    const propre = {};
    Object.keys(m).forEach((id) => { if (ids.indexOf(id) >= 0 && /^[a-z0-9-]{1,20}$/.test(m[id])) propre[id] = m[id]; });
    return propre;
  };
  const nbArticles = () => {
    let n = 0;
    D.querySelectorAll('[data-cart-count]').forEach((el) => { n = Math.max(n, parseInt(el.textContent, 10) || 0); });
    return n;
  };
  const valeurExp = () => {
    // Sans accord connu : seules les paires QA, jamais la mémoire d'une visiteuse
    const m = accordConnu() ? memoire() : {};
    const paires = Object.keys(m).map((id) => `${id}:${m[id]}`);
    X.expositions.forEach((l) => { if (l.source === 'qa') paires.push(`${l.id}:qa-${l.variante}`); });
    let v = '';
    paires.forEach((p) => { if (v.length + p.length + (v ? 1 : 0) <= 80) v = v ? `${v},${p}` : p; });
    return v;
  };
  // Écrit _exp s'il a changé ; une valeur vide retire l'attribut (refus après une écriture)
  function ecrireExp() {
    const v = valeurExp();
    if (v === dernier) return;
    const avant = dernier;
    dernier = v;
    if (accordConnu()) ecrire('sessionStorage', CLE_ECRIT, v);
    const echec = () => { dernier = avant; };
    const api = W.BrossangeCart;
    if (api && typeof api.ecrireAttributs === 'function') {
      // C13 : écriture dans la file d'attente du panier de brossange.js
      Promise.resolve(api.ecrireAttributs({ _exp: v })).catch(echec);
      return;
    }
    fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _exp: v } }),
      credentials: 'same-origin'
    }).then((r) => { if (!r.ok) echec(); }).catch(echec);
  }

  /* 2. Expositions : zone data-exp-zone (ids séparés par des espaces) à moitié visible ou couvrant la moitié de l'écran */
  const exposes = {};
  const attente = [];
  const exposer = (id) => {
    const source = X.src[id];
    const g = X.v[id];
    if (!source || !g || exposes[id]) return;
    // Variante absente de la page (titre vide, variante inconnue du thème) : la visiteuse voit « a », elle n'est pas comptée
    if (g !== 'a' && !variante(id, g)) return;
    if (source === 'cookie' && !accordConnu()) {
      // Accord pas encore connu : en attente, rien n'est écrit ni publié ; refusé : rien
      if (etat === null && attente.indexOf(id) < 0) attente.push(id);
      return;
    }
    exposes[id] = 1;
    const ligne = { id, variante: g, source };
    X.expositions.push(ligne);
    try { D.dispatchEvent(new CustomEvent('brossange:exposition', { detail: ligne })); } catch (e) { /* navigateur ancien */ }
    if (source === 'cookie') {
      const m = memoire();
      m[id] = g;
      ecrire('localStorage', CLE, JSON.stringify(m));
      const deja = (lire('sessionStorage', CLE_VU) || '').split(',').filter(Boolean);
      if (deja.indexOf(`${id}:${g}`) < 0) {
        ecrire('sessionStorage', CLE_VU, deja.concat(`${id}:${g}`).join(','));
        (W.brossangeQ = W.brossangeQ || []).push(['brossange_experiment_exposure', { id, variante: g }]);
      }
    }
    if (nbArticles() > 0) ecrireExp();
  };
  // Observateur créé avant la lecture de l'accord : une zone vue n'est jamais réattribuée sur la page
  const vues = {};
  const zones = Array.from(D.querySelectorAll('[data-exp-zone]'));
  const idsZone = (z) => String(z.dataset.expZone || '').split(/\s+/).filter(Boolean);
  if (zones.length && W.IntersectionObserver) {
    const io = new W.IntersectionObserver((entrees) => entrees.forEach((x) => {
      if (!x.isIntersecting) return;
      const ids = idsZone(x.target);
      ids.forEach((id) => { vues[id] = 1; });
      if (x.intersectionRatio >= 0.5 || x.intersectionRect.height >= W.innerHeight * 0.5) ids.forEach(exposer);
    }), { threshold: [0, 0.25, 0.5, 0.75, 1] });
    zones.forEach((z) => io.observe(z));
  }
  // Zone déjà peinte (dans l'écran ou au-dessus) : mesure synchrone, l'observateur ne répond qu'à l'image suivante
  const dejaVue = (id) => !!vues[id] || zones.some((z) => idsZone(z).indexOf(id) >= 0 && z.getBoundingClientRect().top < W.innerHeight);

  /* 3. Cookie visiteur et attribution sur la page */
  const poserCookie = () => {
    if (X.vid) return X.vid;
    if (!X.cfg.some(ouverte) || !W.crypto || !W.crypto.getRandomValues) return '';
    const octets = W.crypto.getRandomValues(new Uint8Array(16));
    const id = Array.from(octets, (b) => (b < 16 ? '0' : '') + b.toString(16)).join('');
    D.cookie = `${COOKIE}=${id}; Max-Age=${DUREE}; Path=/; SameSite=Lax; Secure`;
    X.vid = id;
    return id;
  };
  const regle = (id, g) => {
    const p = `[data-exp="${id}"]`;
    const s = D.createElement('style');
    s.textContent = `.exp-v${p}[data-exp-v="a"]{display:none}.exp-v${p}[data-exp-v="${g}"]{display:contents}`;
    D.head.appendChild(s);
  };
  const appliquer = (id, g) => {
    const racine = D.documentElement;
    racine.classList.remove(`exp-${id}-${X.v[id] || 'a'}`);
    racine.classList.add(`exp-${id}-${g}`);
    X.v[id] = g;
    X.src[id] = 'cookie';
    if (g !== 'a') regle(id, g);
  };
  const attribuer = () => {
    const vid = poserCookie();
    if (!vid) return;
    const r = X.calc(vid, X.cfg, '', jour());
    Object.keys(r.v).forEach((id) => {
      const g = r.v[id];
      if (X.src[id] || r.src[id] !== 'cookie' || dejaVue(id)) return;
      // Variante non rendue dans cette page (zone absente, titre vide) : attribution à une page qui la montre
      if (!variante(id, g)) return;
      if (D.querySelector(`[data-exp-coche*="${id}:"]`)) return;
      appliquer(id, g);
    });
  };
  const retirer = () => {
    if (X.vid || aCookie()) D.cookie = `${COOKIE}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
    X.vid = '';
    // Variantes attribuées par cookie : plus comptées (l'affichage de la page en cours ne change pas)
    Object.keys(X.src).forEach((id) => { if (X.src[id] === 'cookie') X.src[id] = ''; });
    attente.length = 0;
    effacer('localStorage', CLE);
    effacer('sessionStorage', CLE_VU);
    effacer('sessionStorage', CLE_ECRIT);
    // _exp déjà écrit dans le panier avec l'accord : réécrit sans les variantes de la visiteuse (vide : retiré)
    if (dernier) ecrireExp();
  };
  const surAccord = (a) => {
    etat = a;
    if (!a) { retirer(); return; }
    attribuer();
    attente.splice(0).forEach(exposer);
    if (nbArticles() > 0) ecrireExp();
  };
  const accord = () => { try { return !!W.Shopify.customerPrivacy.analyticsProcessingAllowed(); } catch (e) { return false; } };
  D.addEventListener('visitorConsentCollected', (e) => {
    const a = e.detail && e.detail.analyticsAllowed;
    if (a === true || a === false) surAccord(a);
  });
  try {
    const s = W.Shopify;
    if (s && s.customerPrivacy) surAccord(accord());
    else if (s && typeof s.loadFeatures === 'function') s.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (er) => { if (!er) surAccord(accord()); });
  } catch (e) { /* API absente : accord jamais connu, rien n'est écrit ni publié pour une variante par cookie */ }

  /* 4. Écritures de _exp : compteur du panier, chargement, bouton Commander */
  if (W.MutationObserver) {
    const compteurs = D.querySelectorAll('[data-cart-count]');
    const mo = new W.MutationObserver(() => { if (nbArticles() > 0) ecrireExp(); });
    compteurs.forEach((el) => mo.observe(el, { childList: true, characterData: true, subtree: true }));
  }
  if (nbArticles() > 0) ecrireExp();
  // Bouton Commander (tiroir, page panier) : l'attribut part avec le formulaire, sans requête de plus
  D.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest('[data-checkout-form]');
    const v = form && valeurExp();
    if (!v) return;
    let champ = Array.from(form.querySelectorAll('input[type="hidden"]')).find((i) => i.name === 'attributes[_exp]');
    if (!champ) {
      champ = D.createElement('input');
      champ.type = 'hidden';
      champ.name = 'attributes[_exp]';
      form.appendChild(champ);
    }
    champ.value = v;
  }, true);

  /* 5. brossange.js initialisé : les règles data-exp-masque et data-exp-montre du head cèdent la place au script */
  const pret = () => D.documentElement.classList.add('exp-js');
  D.addEventListener('brossange:panier-pret', pret, { once: true });
  W.addEventListener('load', pret, { once: true });
})();
